import { jarvisOnestockOnboardingConstants } from "./jarvisOnestockOnboardingConstants";

const jarvsiOnestockOnboardingActions = {};

jarvsiOnestockOnboardingActions.updateOnestockOnboardingData = (payload = {}) => ({
    type: jarvisOnestockOnboardingConstants.ONESTOCK_UPDATE_ONBOARDING_DATA,
    payload,
});


jarvsiOnestockOnboardingActions.getOnboardingData = () => ({
  type: jarvisOnestockOnboardingConstants.ONESTOCK_ONBOARDING_DATA_SAGA,
});

export { jarvsiOnestockOnboardingActions };
